import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateNewAddressPage } from './create-new-address.page';

const routes: Routes = [
  {
    path: '',
    component: CreateNewAddressPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateNewAddressPageRoutingModule {}
